function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#a3a9ad;}.cls-3{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 11,
  cy: 10.98,
  r: 9
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M53.29,44.3a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2a11,11,0,1,0,11,11,11,11,0,0,0-11-11Z",
  transform: "translate(-42.29 -42.3)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M52.29,48.88h2v-1.6h-2Zm0,9.4h2v-8h-2Z",
  transform: "translate(-42.29 -42.3)"
});

function SvgInfoButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/Info_Button.3567c118.svg";
export { ForwardRef as ReactComponent };